export enum LogoImageType {
  Main = 'main',
  TopMenu = 'top_menu',
  Footer = 'footer'
}
